import '@fortawesome/fontawesome-pro/css/all.css';
import Vue from 'vue';
import nl from 'vuetify/es5/locale/nl';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: 'fa',
    values: {
      'close': 'far fa-times',
      'menu': 'far fa-bars',
      'delete': 'far fa-trash-alt',
      'add': 'far fa-plus',
      'edit': 'far fa-pencil-alt',
      'search': 'far fa-search',
    },
  },
  customProperties: true,
  lang: {
    locales: {nl},
    current: 'nl',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#5c666f',
        accent: '#00a7ce',
      },
    },
  },
});
